import React from "react";
import {
  PDFViewer,
  Document,
  Page,
  Text,
  View,
  Image,
} from "@react-pdf/renderer";
import LogoIcon from "./PrintApplicationLogo.js";
import PrintApplicationStyles from "./PrintApplicationStyles.js";
import Header from "../../../../assets/images/logo/Letterhead Header.png";

// Import section components
import PrintSection1 from "./Sections/PrintSection1";
import PrintSection2 from "./Sections/PrintSection2";
import PrintSection3 from "./Sections/PrintSection3";
import PrintSection4 from "./Sections/PrintSection4";
import PrintSection5 from "./Sections/PrintSection5";
import PrintSection6 from "./Sections/PrintSection6";
import PrintSection7 from "./Sections/PrintSection7";
import PrintSection8 from "./Sections/PrintSection8";
import PrintSection9 from "./Sections/PrintSection9";
import PrintSection10 from "./Sections/PrintSection10";
import PrintSection11 from "./Sections/PrintSection11";

const RecruitmentApplicationPDF = ({
  userId,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
  section10,
  section11,
}) => {
  return (
    <Document>
      <Page size="A4" style={PrintApplicationStyles.page}>
        <Image src={Header} />

        <Text style={{ ...PrintApplicationStyles.subheading, marginTop: 20 }}>
          Date: {new Date().toLocaleDateString()}
        </Text>

        <Text style={PrintApplicationStyles.subheading}>
          Completing the Individual Application
        </Text>
        <Text style={PrintApplicationStyles.content}>
          The information you supply in this application will form the basis of
          your contract with Rosemount Financial Solutions (IFA) Ltd.
        </Text>
        <Text style={PrintApplicationStyles.content}>
          Much of the information we ask for is prescribed by the Financial
          Conduct Authority (FCA).
        </Text>
        <Text style={PrintApplicationStyles.content}>
          We will acknowledge receipt of your application by email.
        </Text>

        <Text style={PrintApplicationStyles.content}>
          Once we begin processing your application, we will send you, by email,
          an action list. This will show what we are working on and will detail
          any additional information you need to send us.
        </Text>
        <Text style={PrintApplicationStyles.content}>
          The FCA requires us to be satisfied off an individual's suitability to
          perform a Controlled Function or become an Approved Person. We need to
          do this before we can issue a contract, irrespective of whether you
          are already performing one of these roles.
        </Text>

        <Text style={PrintApplicationStyles.content}>
          The FCA considers the following of utmost importance:
        </Text>
        <Text style={PrintApplicationStyles.content}>
          • Honesty, Integrity and Reputation
        </Text>
        <Text style={PrintApplicationStyles.content}>
          • Competence and Capability
        </Text>
        <Text style={PrintApplicationStyles.content}>
          • Financial soundness
        </Text>
        <Text style={PrintApplicationStyles.content}>
          Therefore, it is vitally important that the information you provide is
          'full and frank'; we will need to verify this information to satisfy
          the FCA requirements.
        </Text>
        <Text style={PrintApplicationStyles.content}>
          We want you to start trading as soon as possible. Therefore, it is
          absolutely essential that you provide accurate information. If we
          subsequently discover you have made a material non-disclosure, we will
          terminate your contract. This may appear on any future references we
          are asked to provide, which may make it difficult for you to work with
          any other Authorised Firm.
        </Text>
        <Text style={PrintApplicationStyles.content}>
          If there is anything that may be detrimental to your application, you
          must tell us and explain fully in the Additional Information page at
          the back of the application.
        </Text>
        <Text style={PrintApplicationStyles.content}>
          If in doubt, tell us!
        </Text>
        <Text style={PrintApplicationStyles.content}>
          If you have any questions, please contact the Recruitment Team on
          01256 405460
        </Text>

        {/* Render Individual Sections */}
        <PrintSection1 section1={section1} />
        <PrintSection2 section2={section2} />
        <PrintSection3 section3={section3} />
        <PrintSection4 section4={section4} />
        <PrintSection5 section5={section5} />
        <PrintSection6 section6={section6} />
        <PrintSection7 section7={section7} />
        <PrintSection8 section8={section8} />
        <PrintSection9 section9={section9} />
        <PrintSection10 section10={section10} />
        <PrintSection11 section11={section11} />
      </Page>
    </Document>
  );
};

export default RecruitmentApplicationPDF;
